import { CallQueueCallStatusEnum, useGetCallQueueCallsCountQuery } from '@/types/generated/graphql';

export function useWaitingCallsCount({ skip = false }: { skip?: boolean } = {}) {
  const { data } = useGetCallQueueCallsCountQuery({
    variables: { status: CallQueueCallStatusEnum.waiting },
    fetchPolicy: 'cache-and-network',
    skip,
  });

  return data?.getCallQueueCallsCount?.data?.count ?? 0;
}
